import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Reporting Frequency List with Query (for remote operations)
export const getReportingFrequencyListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_REPORTING_FREQUENCIES}?${stringifyParams(
			params
		)}`
	);
};

// Get Reporting Frequency List
export const getReportingFrequencyList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_REPORTING_FREQUENCIES}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Reporting Frequency
export const getReportingFrequency = reporting_frequency_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_REPORTING_FREQUENCY}${reporting_frequency_id}`
	);
};

// Add New Reporting Frequency
export const addNewReportingFrequencyApi = reporting_frequency => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_REPORTING_FREQUENCY}`,
		reporting_frequency
	);
};

// Update Reporting Frequency
export const updateReportingFrequencyApi = reporting_frequency => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_REPORTING_FREQUENCY}${reporting_frequency._id}`,
		reporting_frequency
	);
};

// Delete Reporting Frequency
export const deleteReportingFrequencyApi = reporting_frequency_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_REPORTING_FREQUENCY}${reporting_frequency_id}`
	);
};

// Check if Reporting Frequency Exists
export const checkReportingFrequencyExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_REPORTING_FREQUENCY_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
